module.exports = __webpack_public_path__ + "static/sport/bgi-dialog.de186d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport/bgi-dialog.png
// module id = HRUs
// module chunks = 0